import React from 'react';
import CompetitionOpeningSoonIcon from '../../../../../../assets/svg/competition-opening-soon.svg';
import CompetitionClosedIcon from '../../../../../../assets/svg/competition-closed.svg';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import { styles } from './CompetitionClosed.css';

export type CompetitionClosedProps = {
  openingDate?: string;
  isBallot: boolean;
};

type Content = {
  Image: React.FC;
  Heading: React.FC<{ isBallot: boolean }>;
  Body: React.FC<{ openingDate?: string; isBallot: boolean }>;
};

enum ContentVariants {
  openingSoon = 'openingSoon',
  closed = 'closed',
}

const content: Record<ContentVariants, Content> = {
  openingSoon: {
    Image: CompetitionOpeningSoonIcon,
    Heading: ({ isBallot }: { isBallot: boolean }) => `${isBallot ? 'Ballot' : 'Competition'} opening soon!`,
    Body: ({ openingDate, isBallot }: { openingDate?: string; isBallot: boolean }) =>
      isBallot ? (
        <>
          <p>This ballot will open on the {openingDate} at 10:00am AEST.</p>
        </>
      ) : (
        <>
          <p>
            This competition is not open yet but watch this space (page) as the entry form will be ready for you when
            the competition opens on {openingDate}.
          </p>
          <p>
            Feeling competitive while you wait? <a href="/blogs/competitions">Check out our other competitions</a>
          </p>
        </>
      ),
  },
  closed: {
    Heading: ({ isBallot }: { isBallot: boolean }) =>
      `Sorry, this ${isBallot ? 'ballot' : 'competition'} has now closed.`,
    Image: CompetitionClosedIcon,
    Body: () => (
      <>
        <p>
          Check our <a href="/blogs/competitions/competition-winners">winners section</a> if you’ve already entered.
          Otherwise, never miss a comp by bookmarking our <a href="/blogs/competitions">competitions home</a>.
        </p>
        <p>
          <JBButton type="primary" href="/blogs/competitions" label="View all competitions" />
        </p>
      </>
    ),
  },
};

export const CompetitionClosed = ({ openingDate, isBallot }: CompetitionClosedProps) => {
  const { Image, Heading, Body } = content[openingDate ? ContentVariants.openingSoon : ContentVariants.closed];

  return (
    <div className={styles.container}>
      <Image />
      <h3 className={styles.heading}>
        <Heading isBallot={isBallot} />
      </h3>
      <div className={styles.body}>
        <Body openingDate={openingDate} isBallot={isBallot} />
      </div>
    </div>
  );
};
